<template>
  <div class="form-field select-search" ref="container">
    <label for="">{{ title }}</label>
    <div class="multiple-locations-available" v-if="multipleLocationsAvailable && title === 'Pick Up From:'">(Multiple Locations Available)</div>
    <div
      class="input"
      @click="toggleSearch()"
    >
      <img src="/images/pin.png" alt="Location Pin Icon" />
      <!-- <span class="material-symbols-outlined">place</span> -->
      <span v-if="selected && selected.title">{{ selected.title }}</span>
      <span v-else>{{isDropoff ? 'Same as Pickup' : 'Select a Location'}}</span>
      <img src="/images/expand_more.svg" class="expand-img" />
    </div>

    <!-- <div
      v-if="isOpen"
      @click="isOpen = false"
      class="background"
    ></div> -->

    <div class="results" v-if="isOpen">
      <div class="flex form-field">
        <input
          type="text"
          v-model="text"
          @keyup="onFilterLocations()"
        >
        <button>
          <span class="material-icons-outlined">search</span>
        </button>
      </div>

      <div class="wrap" ref="wrap">
        <ul>
          <li v-for="location of sortedLocations" :key="location.id">
            <a @click="selectLocation(location)">{{ location.title }}</a>
          </li>
        </ul>
      </div>

      <div class="down-btn">
        <img src="/images/expand_more.svg" @click="scrollDownList()"/>
        <!-- <span class="material-symbols-outlined">expand_more</span> -->
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    locations: Array,
    init_id: Number | String,
    title: String,
    isDropoff: {
      type: Boolean,
      default: false,
    },
    multipleLocationsAvailable: {
      type: Boolean,
      default: false,
    },
  },

  data: () => ({
    selected: {},
    sortedLocations: [],
    isOpen: false,
    text: '',
    ref: null,
    scrollQueue: [],
  }),

  mounted () {
    this.sortedLocations = this.locations
    if (this.init_id) {
      // pre-select location
      this.selected = this.sortedLocations.find(obj => obj.id == this.init_id)
    }
    document.body.addEventListener('click', this.isClickOutside)
  },

  destroyed() {
    document.body.removeEventListener('click', this.isClickOutside)
  },

  computed: {
    isChrome () {
      return navigator?.userAgent?.indexOf('Chrome') > -1;
    },

    isFirefox () {
      return navigator?.userAgent?.indexOf('Firefox') > -1;
    },
  },

  methods: {
    getWheelDistance (e) {
      let wheelDelta = e?.wheelDelta
      let deltaY = e.deltaY

      if (wheelDelta) {
        return -wheelDelta / 120
      }

      return deltaY > 0 ? 1 : -1
    },

    onScroll (e) {
      e.preventDefault()

      // Normalize wheel distance
      let delta = this.getWheelDistance(e)

      let finalDistance = delta === -1 ? -34 : 34

      if (this.isChrome || this.isFirefox) {
        finalDistance = delta === -1 ? -11 : 11
      }

      this.$refs.wrap.scrollBy({
        top: finalDistance,
        left: 0,
        behavior: 'smooth'
      })
    },

    isClickOutside(e) {
      if (e?.target === this.$refs.container || this.$refs.container?.contains(e?.target)) {
        return
      }

      this.isOpen = false
    },

    scrollDownList () {
      if (this.isChrome || this.isFirefox) {
        this.$refs.wrap.scrollBy(0, 11)
      } else {
        this.$refs.wrap.scrollBy(0, 34)
      }
    },

    selectLocation (obj) {
      this.selected = obj
      this.$emit('selectedLocation', this.selected.id)
      this.isOpen = false
    },

    onFilterLocations () {
      if (this.text) {
        var arrayFiltered = this.locations.filter( (obj) => {
            return obj.title.toLowerCase().indexOf(this.text.toLowerCase()) != -1
        });
        this.sortedLocations = arrayFiltered;
      } else {
        this.sortedLocations = this.locations
      }
    },

    toggleSearch () {
      this.isOpen = !this.isOpen
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.form-field.select-search {
  position: relative;
  width: 100%;

  @media (min-width: 1281px) {
    width: 217px;
  }

  label {
    margin-bottom: 6px;
  }

  .background {
    position: fixed;
    top: 0;
    left: 0;
    z-index: 9999;

    width: 100%;
    height: 100%;
  }

  .input {
    height: fit-content;
    overflow: hidden;
    padding: 12px;
    display: flex;
    align-items: center;
    height: 44px;
    border-radius: 3px 0 0 3px;
    border-right: solid 1px #E4E7ED;
    gap: 8px;

    img {
      width: 16px;
      height: 20px;
    }

    .expand-img {
      margin-left: auto;
    }

    .material-symbols-outlined {
      font-size: 25px;
      text-align: center;
      color: #EC1C24;
      padding-right: 4px;
      font-variation-settings: 'FILL' 1;
    }
  }

  .multiple-locations-available {
    color: #EC1C24;
    font-size: 13px;
    margin-bottom: 6px;
    font-weight: 500;
  }

  .results {
    position: absolute;
    top: calc(100% + 3px);
    left: -1px;
    z-index: 9999;

    margin: 0;
    padding: 0;

    background: white;
    border: 1px solid #E4E7ED;
    border-radius: 4px;
    box-shadow: 0 2px 12px 0 rgba(0,0,0,0.06);

    @media (max-width: 600px) {
      width: 100%;
    }

    @media (min-width: 769px) {
      min-width: 345px;
    }

    .form-field {
      margin: 0;
      padding: 3px 4px 7px 3px;

      font-size: 15px;
      font-weight: 400;
      letter-spacing: 0.1px;

      input {
        display: inline-block;
        height: 31px;
        width: 100%;
        padding: 0 10px;

        border: 2px solid #000000;
        border-radius: 3px;
        background-color: #FFFFFF;
      }

      button {
        position: absolute;
        top: 7px;
        right: 5px;
        display: inline-block;
        width: 30px;
        user-select: none;

        span.material-icons-outlined {
          font-size: 22px;
          user-select: none;
        }

        img {
          user-select: none;
        }
      }
    }

    .wrap {
      height: 240px;
      max-height: 240px;
      padding: 0;
      // padding: 0 15px 0 0;

      -ms-overflow-y: scroll;
      overflow-y: scroll;
      overflow-x: hidden;
     // -ms-scroll-snap-type: mandatory;
     // scroll-snap-type: y mandatory;

      &::-webkit-scrollbar {
       // display: none;
      }

      ul {
        margin: 0;
        padding: 0;

        li {
          margin: 0;
          padding: 5px 11px;

          font-size: 12.5px;
          line-height: 24px;
          color: black;
          transition: all 0ms !important;

          scroll-snap-align: start;

          a {
            transition: all 0ms !important;
            display: inline-block;
            width: 100%;
          }
        }

        li:hover {
          background-color: red;
          a { color: white; }
        }
      }
    }

    .down-btn {
      display: flex;
      justify-content: center;

      height: 24px;
      cursor: pointer;

      .material-symbols-outlined {
        background-color: transparent;
        width: 100%;
        height: 44px;
        font-size: 22px;
        font-weight: 100;
        text-align: center;
        color: #3B3E40;
        padding: 1px 0 0 2px;
      }
    }
  }
}
</style>
